import script from "./PlanEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlanEdit.vue?vue&type=script&lang=ts&setup=true"

import "./PlanEdit.vue?vue&type=style&index=0&id=f4fdeea4&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4fdeea4"]])

export default __exports__